<!-- eslint-disable max-lines -->
<template>
    <paper v-loading="btnloading" class="customer-mip-iframe custoemr-change-home">
        <div class="top-box">
            <!-- 标题区域 -->
            <div class="header-box">
                <h4>{{ customerTitle }}</h4>
                <div class="header-info-crm">
                    <!-- 按钮区域 -->
                    <div class="detail-toolBar">
                        <lots-button type="primary" v-if="isShowBtn['submit']" :loading="submitFlowLoading" :disabled="currentEditStatus"
                            @click="handleFlow">{{ detailDataLocal.mipId ? 'mip提交' : '提交审批' }}
                        </lots-button>
                        <lots-button type="primary" v-if="isShowBtn['save']" :loading="saveLoading"
                            @click="handleSave">保 存
                        </lots-button>
                        <lots-button type="primary" v-if="isShowBtn['comparison']" @click="handleComparison">变更对比
                        </lots-button>
                        <!-- <lots-button type="primary"
                            v-if="readonly && ![2, 3, 4, 7].includes(+detailDataLocal.mipStatus)" @click="handleEdit">编辑
                        </lots-button> -->
                    </div>
                    <div class="apply-info" v-if="detailDataLocal.customerChangeCode">
                        <div>单据编号：{{ detailDataLocal.customerChangeCode }}</div>
                        <div>申请人：{{ detailDataLocal.createUserName }}</div>
                        <div>申请日期：{{ detailDataLocal.createTime }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="customer-change-info" v-loading="detailLoading">
            <!-- 表单区域 -->
            <collapse-infos ref="upholdHealder" class="customer-change-collapse" :detailData="detailDataLocal"
                :collapse="COLLAPSE" :activeCollapses="activeCollapses" @change="handleInfosChange" :addedDictKeys="addedDictKeys">
                <!-- 折叠筐标题插槽 -->
                <template v-slot:collapse-title-append="{ collapseItem }">
                    <span>{{ collapseItem.title }}</span>
                </template>
                <!-- 表单字段插槽 -->
                <template v-slot:collapse-append="{ form, itemSetting, rIndex, collapseItem, dictData }">
                    <span v-if="itemSetting.prop === 'industryType'">
                        <el-cascader
                            v-if="industryTypeDisabled"
                            class="customer-cascader-select" size="mini" v-model="form[itemSetting.prop]"
                            :show-all-levels="false" :checkStrictly="false" :options="industryData"
                            :props="itemSetting.props" collapse-tags :clearable="true" :filterable="true"
                            :change-on-select="itemSetting.changeOnSelect" :placeholder="itemSetting.name"
                            @change="(data) => { customAppendChange(data, itemSetting.prop); }">
                        </el-cascader>
                        <span :title="formatIndustry()" v-else>{{ formatIndustry() }}</span>
                    </span>
                    <span v-else-if="['businessScope', 'ebcuRemark'].includes(itemSetting.prop)">
                        <span class="customer-text-area"
                            :title="(form[itemSetting.prop] || form[itemSetting.prop] === 0) ? form[itemSetting.prop] : '--'"
                            v-html="(form[itemSetting.prop] || form[itemSetting.prop] === 0) ? form[itemSetting.prop] : '--'"></span>
                    </span>
                    <span
                        v-else-if="['customerName'].includes(itemSetting.prop) && detailDataLocal.customerChangeType === '1'">
                        <span v-if="customerNameFiledStatus" class="customer-name-edit">
                            <span class="customer-name-text" :title="detailDataLocal.customerName">{{
                                detailDataLocal.customerName }}</span>
                            <span>-</span>
                            <span class="customer-name-input">{{
                                detailDataLocal.virtualName
                                }}</span>
                        </span>
                        <span v-else class="customer-name-edit">
                            <span class="customer-name-text" :title="detailDataLocal.customerName">{{
                                detailDataLocal.customerName }}</span>
                            <span class="customer-name-tips">-</span>
                            <el-input class="customer-name-input" placeholder="请输入"
                                v-model.trim="detailDataLocal.virtualName" @change="virtualNameChange"></el-input>
                        </span>

                    </span>
                    <span v-else-if="['addressCode'].includes(itemSetting.prop)" class="custom-span"
                        :title="formatAddress()">
                        <el-cascader
                            v-if="industryTypeDisabled"
                            class="address-custom" v-model="form[itemSetting.prop]" :key="addressCodeKey"
                            ref="customerAddressRef" @change="addressChange(form, itemSetting, 'change')" @visible-change="visibleChange"
                            :props="itemSetting.props" :filterable="true" :filter-method="addressFilter" popper-class="address-popper-custom ">
                            <template slot-scope="{ node, data }">
                                <div class="cascader-custom">
                                    <el-tooltip class="item" :disabled="showTooltip" effect="light"
                                        :content="data.label" placement="top">
                                        <p @mouseenter="mouseenterHandle($event)">{{ data.label }}</p>
                                    </el-tooltip>
                                    <el-tooltip class="item" :disabled="showTooltip" effect="light"
                                        :content="formatCascaderDataCn(data) ? data.nameLo : ''" placement="top">
                                        <p v-if="formatCascaderDataCn(data)" @mouseenter="mouseenterHandle($event)">{{
                                            data.nameLo }}</p>
                                    </el-tooltip>
                                    <el-tooltip class="item" :disabled="showTooltip" effect="light"
                                        :content="formatCascaderDataEn(data) ? data.nameEn : ''" placement="top">
                                        <p v-if="formatCascaderDataEn(data)" @mouseenter="mouseenterHandle($event)">{{
                                            data.nameEn }}</p>
                                    </el-tooltip>
                                </div>
                            </template>
                        </el-cascader>
                        <span :title="formatAddress()" v-else>{{ formatAddress() }}</span>
                    </span>
                    <span class="customer-id-number" v-else-if="itemSetting.prop === 'idNumber'" :key="encryption[itemSetting.prop]">
                        <span> {{ encryptionHandle(form[itemSetting.prop], itemSetting.prop) || '--'}}</span>
                            <img v-if="encryptionHandle(form[itemSetting.prop], itemSetting.prop)" :class="['text-eyes']" @click="handleChangeText(itemSetting)"
                                :src="encryption[itemSetting.prop] ? iconOpenEyes : iconCloseEyes" alt="">
                    </span>
                    <span v-else-if="itemSetting.prop === 'targetStatus'" class="custom-span"
                        :title="form[itemSetting.prop]">
                        {{ formatTarget(form[itemSetting.prop], itemSetting) }}
                    </span>
                    <span v-else-if="!itemSetting.optionsKey" class="custom-span" :title="form[itemSetting.prop]">
                        {{ (form[itemSetting.prop] || form[itemSetting.prop] === 0) ? form[itemSetting.prop] : '--' }}
                    </span>
                </template>
            </collapse-infos>

            <!-- iflow区域 -->
            <el-collapse v-if="detailDataLocal.mipId" class="contract-collapse detail-more-collapse" value="mipInfo">
                <el-collapse-item title="流程信息" name="mipInfo">
                    <iframe class="ifr" :src="mipUrl" v-if="!btnloading" />
                </el-collapse-item>
            </el-collapse>
        </div>
        <customerComparisonDialog ref="comparisonRef" />
    </paper>
</template>

<script>
import { ref, computed, getCurrentInstance, onActivated } from '@vue/composition-api';
import paper from '@/components/core/Paper.vue';
import lotsButton from '@/components/lots/lotsButton';
import CollapseInfos from '@/modules/mdm/views/contractModules/components/collapseInfos/CollapseInfos.vue';
import { getIndustryTree } from '@mdm/api/contractManage/contractRegistration.js';
import {
    getCustomerGroupTips, getCustomerByCode, saveVirtualInfo, saveChangeCustomer, saveStatusCustomer,
    submitVirtualFlow, submitChangeFlow, submitStatusFlow,
    queryFlowByCustomer
} from '@/modules/mdm/api/customer/customerManage.js';
import { getNodesAndOperationApi } from '@mdm/utils/flowUtils.js';
import {
    getAuthorByProcessIdApi
} from '@mdm/api/contractManage/mipIframeApi.js';
import { approveProcess } from '@/modules/mdm/api/contractManage/detailMainApi.js';
import { Message } from 'element-ui';
import store from '@/store/index';
import utils from '@/components/utils/common.js';
import { collapse, targetStatusList, initTargetStatusList, addedDictKeys } from './collapseInfosConfig.js';
import _ from 'lodash';
import configurl from '@/config/user.env';
import { getDictDataApi } from '@mdm/api/contractManage/contractListApi.js';
import customerComparisonDialog from './customerComparisonDialog/Index.vue';
import { noChineseReg } from '@/modules/mdm/utils/regList.js';
import Bus from '@/utils/bus.js';
// import advanceMultiDialog from '@/components/lots/otpAdvanceMultiDialog';
import otherUtils from '@/modules/mdm/utils/otherCommonFunc.js';
import iconOpenEyes from '@/assets/images/icon-open-eyes.png';
import iconCloseEyes from '@/assets/images/icon-close-eyes.png';
const { MAGIC_NUMBER } = utils;
const MAGIC_HEIGHT = '89'; // 顶部高度
export default {
    name: 'customerChangeFlow',
    components: {
        paper,
        lotsButton,
        CollapseInfos,
        customerComparisonDialog
        // advanceMultiDialog
    },
    props: {
        detailPageState: {
            type: String,
            default() {
                return '';
            }
        },
        detailData: {
            type: Object,
            return: () => { }
        }
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const ctx = getCurrentInstance(); // 通过该方法访问当前组件的实例对象,相当于this
        const config = _.cloneDeep(collapse);
        const detailLoading = ref(false);
        const btnloading = ref(false);
        const disabledFlag = ref(false);
        const code = ref('');
        const detailDataLocal = ref({});
        const isShowBtn = computed(() => {
            const { mipStatus, customerChangeType, id } = detailDataLocal.value;
            return {
                save: ['', null, undefined, '1', '5', '6'].includes(mipStatus?.toString()),
                submit: ['', null, undefined, '1', '3', '5', '6'].includes(mipStatus?.toString()),
                comparison: customerChangeType === '2' && id
            };
        });
        // eslint-disable-next-line max-len
        const activeCollapses = ref(['basicInfo', 'manageInfo', 'registerInfo', 'financeInfo', 'otherInfo', 'systemInfo']);
        const mipUrl = ref('');
        const lodash = computed(() => { return _; });
        const newPageStatus = computed(() => {
            return detailDataLocal.value.customerStatus?.toString() === '0';
        });
        // 客户变更类型
        const customerTypeData = computed(() => {
            const { industryCategoriesCode, isVirtualCustomer, customerChangeType } = detailDataLocal.value;
            return {
                isVirtual: isVirtualCustomer?.toString() === 'Y', // 虚拟客户
                isStatus: customerChangeType?.toString() === '3', // 变更类型：客户状态变更申请
                isUpdate: customerChangeType?.toString() === '2', // 变更类型：客户信息变更申请
                isOverseas: industryCategoriesCode?.toString() === '221' // 行业大类：海外物流
            };
        });
        let initCustomerKey = 1;
        /**
         * 1 客户新增
         * 2 虚拟客户新增
         * 3 客户修改信息
         * 4 虚拟客户修改信息
         * 5 客户状态变更
         * */
        const COLLAPSE = computed(() => { // 配置项动态计算
            const { customerChannel, customerName, customerBodyType, isRelatedTransaction, customerStatus, isVirtualCustomer,
                mipStatus, customerChangeType, isImpExpCustomer } = detailDataLocal.value;
            const { isUpdate, isStatus, isVirtual, isOverseas } = customerTypeData.value;

            // eslint-disable-next-line max-lines-per-function
            config.forEach((v, i) => {
                if (['financeInfo', 'otherInfo'].includes(v.formName) && !_.isNil(isVirtualCustomer)) {
                    v.visible = !isVirtual;
                }
                // eslint-disable-next-line complexity, max-lines-per-function
                v.formList.forEach((v2, i2) => {
                    // 更新状态:除了更新状态targetStatus可编辑, 其他都是不可编辑的  新增申请原因可编辑
                    if (v2.prop === 'targetStatus') {
                        v2.type = !['3', '4', '7'].includes(mipStatus?.toString()) && isStatus ? 'select' : 'custom';
                        v2.options = ['3', '4', '7'].includes(mipStatus?.toString()) ? initTargetStatusList : targetStatusList[customerStatus] || [];
                        v2.visible = isStatus;
                    }
                    if (v2.prop === 'ebcuRemark') {
                        v2.type = !['3', '4', '7'].includes(mipStatus?.toString()) ? 'input' : 'custom';
                    }
                    if (['belongCustomerCode', 'belongCustomerName', 'belongCustomerGroupName', 'belongIndustryCategoriesName',
                        'belongCustomerChannel', 'belongRiskLevel'].includes(v2.prop) && v.formName === 'basicInfo') {
                        v2.visible = customerChangeType === '1';
                    }
                    if (['supplierCode'].includes(v2.prop)) { // 供应商编码
                        v2.type = (isVirtual || isUpdate) && !isOverseas ? 'advance' : 'custom';
                    }
                    if (['customerName'].includes(v2.prop)) { // 客户名称
                        v2.type = isUpdate && customerChangeType !== '1' ? 'input' : 'custom';
                        // eslint-disable-next-line no-magic-numbers
                        v2.span = customerChangeType === '1' ? 12 : 6;
                    }
                    // if (['customerCode'].includes(v2.prop)) {
                    //     v2.visible = customerChangeType !== '1';
                    // }

                    if (v2.prop === 'customerShortName') { // 客户简称
                        v2.visible = !isVirtual; // 虚拟客户为隐藏
                        v2.rule[0].required = !isVirtual; // 非虚拟客户必填
                        v2.type = isUpdate ? 'input' : 'custom';
                    }
                    if (v2.prop === 'ebcuNameEn') { // 英文名称
                        v2.visible = !isVirtual;
                        v2.type = isUpdate ? 'input' : 'custom';
                        v2.rule[0].required = !isVirtual && customerBodyType === '2'; // 新判断:判断客户控制类型为 海外 且非虚拟客户
                    }
                    if (['isVirtualCustomer'].includes(v2.prop)) { // 虚拟客户
                        v2.visible = isVirtual;
                    }
                    if (['belongCustomerCode', 'riskLevel'].includes(v2.prop) && v.formName === 'manageInfo') { // 虚拟客户
                        v2.visible = customerChangeType !== '1';
                    }
                    if (v2.prop === 'customerGroupName') { // 客户系
                        v2.rule[0].required = isVirtual || isUpdate;
                        v2.type = isVirtual || isUpdate ? 'advance' : 'custom';
                        initCustomerKey = 1;
                        v2.beforeRequest = params => {
                            initCustomerKey === 1 && getCustomerGroupTipsInfo();
                            params.alikeName = customerName;
                            params.enableFlag = 1;
                            return params;
                        };
                    }
                    if (['industryType'].includes(v2.prop)) { // 细分行业
                        v2.rule[0].required = isVirtual || isUpdate;
                    }
                    if (['ebcuCustomerType', 'ebcuBuCode'].includes(v2.prop)) { // 客户分类/所属事业部
                        v2.rule[0].required = isVirtual || isUpdate;
                        v2.type = (isVirtual || isUpdate) && !isOverseas ? 'select' : 'custom';
                    }
                    if (['ebcuCustomerType'].includes(v2.prop)) {
                        v2.optionsKey = ['0', '2'].includes(isImpExpCustomer?.toString()) ? 'EBCU_CUSTOMER_TYPE' : 'EBCU_CUSTOMER_TYPE_OVERSEAS';
                    }
                    if (['teamType'].includes(v2.prop)) { // 战略合作类型
                        v2.visible = isStatus;
                    }
                    if (['isImpExpCustomer'].includes(v2.prop)) { // 内外销客户
                        v2.rule[0].required = isVirtual;
                        v2.type = isVirtual && !isOverseas ? 'select' : 'custom';
                    }
                    if (['customerChannel'].includes(v2.prop)) { // 内外渠-信息变更时可改
                        v2.rule[0].required = isVirtual || isUpdate;
                        v2.type = (isVirtual || (isUpdate && ['0', '1'].includes(customerBodyType?.toString()))) && !isOverseas ? 'select' : 'custom';
                    }
                    if (['originalGroupCode', 'customerBodyType', 'ebcuPlatformNature'].includes(v2.prop)) { // 客户集团编码
                        v2.visible = !isVirtual;
                    }
                    if (['customerChannelRole'].includes(v2.prop)) { // 美的渠道角色
                        v2.rule[0].required = ((isVirtual || isUpdate) && !isOverseas) && String(customerChannel) === '3';
                        v2.type = v2.rule[0].required ? 'select' : 'custom';
                    }

                    if (['customerOwnerName'].includes(v2.prop)) { // 客户经理/开发人
                        v2.rule[0].required = isVirtual;
                        v2.type = isVirtual && !isOverseas ? 'advance' : 'custom';
                    }

                    if (['societyCreditCode', 'ebcuLegalEntity'].includes(v2.prop)) { // 社会信用代码/法人代表
                        v2.rule[0].required = ['1'].includes(customerBodyType) && isUpdate; // 客户控制类型为法人时，显示且只读；
                        // 客户控制类型为空/非法人时，隐藏且清空；
                        v2.visible = isVirtual ? false : ['1'].includes(customerBodyType);
                    }
                    if (['ebcuBusinessNo'].includes(v2.prop)) { // 营业执照号/注册号
                        // 客户控制类型为空、非法人时，隐藏且清空；
                        v2.visible = isVirtual ? false : ['1', '2'].includes(customerBodyType);
                    }
                    if (['ebcuTaxRegistNo'].includes(v2.prop)) { // 纳税号
                        v2.type = isUpdate && !isOverseas && ['1'].includes(customerBodyType) ? 'input' : 'custom'; // √客户控制类型为法人 / 个体户时，显示且可编辑；
                        v2.visible = isVirtual ? false : ['1'].includes(customerBodyType);
                    }
                    if (['ebcuOrgBarcode', 'tycAddress'].includes(v2.prop)) { // 组织机构代码/注册地址
                        // 客户控制类型为空、非法人、海外客户时，隐藏且清空；
                        v2.visible = isVirtual ? false : ['1'].includes(customerBodyType);
                    }
                    if (['sinosureCode'].includes(v2.prop)) { // 中信保编码
                        v2.type = isUpdate && !isOverseas && ['2'].includes(customerBodyType) ? 'input' : 'custom'; // 客户控制类型为海外客户时，显示且可编辑；客
                        v2.visible = isVirtual ? false : ['2'].includes(customerBodyType);
                    }

                    if (['idNumber'].includes(v2.prop)) { // 身份证
                        // √客户控制类型为非法人时，显示且只读且必填；
                        v2.type = 'custom';
                        v2.rule[0].required = isUpdate && ['0'].includes(customerBodyType);
                        v2.visible = isVirtual ? false : ['0'].includes(customerBodyType);
                    }
                    // 纳税登记人 纳税人类型 注册金额 经营范围
                    if (['businessScope', 'ebcuRegisteredCapital', 'ebcuTaxpayersType', 'ebcuTaxpayers'].includes(v2.prop)) {
                        // 客户控制类型为法人/个体户时，显示且只读且必填；
                        v2.rule[0].required = isUpdate && !isOverseas && ['1'].includes(customerBodyType);
                        v2.visible = isVirtual ? false : ['1'].includes(customerBodyType);
                        if (v2.prop === 'ebcuTaxpayersType') { // 纳税人类型
                            v2.type = v2.rule[0].required ? 'select' : 'custom';
                        }
                        if (['businessScope', 'ebcuRegisteredCapital'].includes(v2.prop)) {
                            v2.type = v2.rule[0].required ? 'input' : 'custom';
                        }
                    }

                    // 国家省市区
                    if (['addressCode'].includes(v2.prop)) {
                        v2.rule[0].required = isUpdate;
                        v2.type = 'custom';
                    }
                    if (['ebcuAddress'].includes(v2.prop)) { // 地址
                        v2.rule[0].required = isVirtual || isUpdate;
                        v2.type = (isVirtual || isUpdate) && !isOverseas ? 'input' : 'custom';
                    }
                    // 是否关联交易 是否POS机收款
                    if (['isRelatedTransaction', 'receiveByPos'].includes(v2.prop)) {
                        v2.visible = !isVirtual;
                        v2.rule[0].required = isUpdate;
                        v2.type = isUpdate && !isOverseas ? 'select' : 'custom';
                    }
                    // 内部OU组织
                    if (['ouOrganizationName'].includes(v2.prop)) {
                        v2.visible = !isVirtual;
                        v2.rule[0].required = isUpdate && !isOverseas && isRelatedTransaction === '1';
                        v2.type = v2.rule[0].required ? 'advance' : 'custom';
                    }
                    // 客户大类
                    if (['customerCategory', 'customerCategoryCode'].includes(v2.prop)) {
                        v2.visible = isVirtual || isUpdate;
                    }

                    if (['ebcuIfSucceedGroupCustomer', 'ebcuIfRawGroupCustomer', 'ebcuIsCustomer', 'isSupplierGenerate', 'ebcuIfNewCard'].includes(v2.prop)) {
                        v2.visible = false;
                    }
                    // 前面需要判断字段是否显示以及是否必填, 审批中,通过,废弃为只读
                    if ((!['targetStatus', 'ebcuRemark'].includes(v2.prop) && isStatus)) {
                        v2.type = 'custom';
                        return;
                    }
                    if (['3', '4', '7'].includes(mipStatus?.toString())) {
                        v2.type = 'custom';
                    }
                });
            });

            return config;
        });
        // 只读状态 状态修改 和通过, 审批中 废弃
        const customerNameFiledStatus = computed(() => {
            const { mipStatus } = detailDataLocal.value;
            const { isStatus } = customerTypeData.value;
            return !!(['3', '4', '7'].includes(mipStatus?.toString()) || isStatus);
        });
        const newMip = ref(false);
        const addressCodeKey = ref(1);
        // 处理详情返回数据格式
        const formatData = (data) => {
            addressCodeKey.value++;
            const newData = _.cloneDeep(data);
            !newData.relatedFiles && (newData.relatedFiles = []);
            if (!Array.isArray(newData.industryType) && newData.industryCategoriesCode) {
                newData.industryType = [newData.industryCategoriesCode, newData.industryTypeCode || newData.industryType];
            }
            newData.addressCode = generateAddressArray(data.ebcuEbplCountryCode, data.ebcuEbplProvinceCode, data.ebcuEbplCityCode, data.ebcuDistricts, data.ebcuTowns);
            return newData;
        };
        const generateAddressArray = (country, province, city, district, towns) => {
            const result = [];
            result.push(country);
            // 如果没有省级编码，直接返回空数组
            if (!province) {
                return result;
            }

            // 添加省级编码
            result.push(province);

            // 如果有市级编码，添加省市组合
            if (city) {
                result.push(city);

                // 如果有区级编码，添加省市区组合
                if (district) {
                    result.push(district);
                    if (towns) {
                        result.push(towns);
                    }
                }
            }

            return result;
        };
        const dictDatas = ref({});
        const { userName, userCode } = store.getters.user;
        // eslint-disable-next-line complexity
        const _initData = async () => {
            const { customerChangeCode, customerCode } = ctx.$route.query;
            detailLoading.value = true;
            const res = await getDictDataApi({
                dictCodes: 'CONTRACT_RENEWAL_REGISTRATION,NEOCRM_CUSTOMER_LEVEL,SYS_BMS_BUSI_TYPE,CRM_CONTRACT_RENEWAL_RISK,NEOCRM_WH_TYPE,CRM_CONTRACT_RENEWAL_RISK,CRM_CONTRACT_RENEWAL_RISK_CAUSE'
            });
            dictDatas.value = res.data;
            if (customerChangeCode || customerCode) {
                await getCustomerByCodeInfo();
                await getIflowhandlers(detailDataLocal.value.mipId);
            }
            detailLoading.value = false;
            isNeedSaveAndSubmit.value = false;
            handleInfosChange({ form: formatData(detailDataLocal.value) });
        };
        const currentAuth = ref(false);
        const isHandleEdit = ref(false);
        const isNeedSaveAndSubmit = ref(false);
        const oldDetailData = ref({});
        // eslint-disable-next-line complexity
        const handleInfosChange = async (formObjData = {}) => { // 表单组件编辑回调，更新本地数据
            const { targetForm, itemSetting } = formObjData;
            // 监控表单是否编辑过
            isHandleEdit.value = Boolean(itemSetting);
            if (!itemSetting) { // 页面初始化、刷新时走：
                if (detailDataLocal.value.mipId) {
                    handleCreate(); // 渲染iflow流程
                    currentAuth.value = await getNodesAndOperationApi({ fdId: detailDataLocal.value.mipId, loginName: userCode });
                }
                detailDataLocal.value = formObjData.form;
                oldDetailData.value = _.cloneDeep(formObjData.form);
                setupContext.refs.upholdHealder && setupContext.refs.upholdHealder.clearValidate(); // 重置校验报错
                setupContext.refs.upholdHealder && setupContext.refs.upholdHealder.refleshPage(detailDataLocal.value); // 刷新表单子组件
                // setupContext.refs.upholdHealder && setupContext.refs.upholdHealder.updataInitData(detailDataLocal.value);
            } else { // collapse组件编辑回调时走：
                if (['industryType', 'customerGroupName', 'customerChannel'].some(key => itemSetting.prop?.includes(key))) {
                    isNeedSaveAndSubmit.value = true;
                }
                if (['customerChannelRole'].includes(itemSetting.prop)) {
                    // 客户控制类型为空、非法人时，隐藏且清空；
                    targetForm['isSaleCompany'] = targetForm[itemSetting.prop] === '1' ? '1' : '0';
                    targetForm['isAgent'] = targetForm[itemSetting.prop] === '2' ? '1' : '0';
                    targetForm['isDistributor'] = targetForm[itemSetting.prop] === '3' ? '1' : '0';
                } else if (['customerName'].includes(itemSetting.prop)) {
                    targetForm[itemSetting.prop] = targetForm[itemSetting.prop]?.trim() || '';
                    initCustomerKey = 1; // 重新更新客户系提示
                } else if (['customerShortName', 'ebcuNameEn'].includes(itemSetting.prop)) {
                    targetForm[itemSetting.prop] = targetForm[itemSetting.prop]?.trim() || '';
                } else if (['customerChannel'].includes(itemSetting.prop)) {
                    targetForm['customerChannelRole'] = targetForm[itemSetting.prop] === '3' ? targetForm['customerChannelRole'] : '';
                    targetForm['isGroupCustomer'] = targetForm[itemSetting.prop] === '2' ? '1' : '0'; // 内外渠为纯外部或美的渠道时带出外部，内外渠为内部时带出内部
                } else if (itemSetting.prop === 'isRelatedTransaction') {
                    targetForm['ouOrganizationName'] = +targetForm['isRelatedTransaction'] === 1 ? targetForm['ouOrganizationName'] : '';
                    targetForm['ouOrganization'] = +targetForm['isRelatedTransaction'] === 1 ? targetForm['ouOrganization'] : '';
                }
                const { relatedFiles } = detailDataLocal.value;
                // 除了插槽参数以外，其他参数取最新编辑的参数更新(因：插槽的编辑不会触发collapse组件change事件回调，因此change事件回调的插槽的参数是旧数据不能取)
                detailDataLocal.value = Object.assign(
                    {},
                    detailDataLocal.value,
                    formObjData.form,
                    targetForm,
                    { relatedFiles } // 保证插槽数据用最新的
                );
            }
            // detailDataLocal.value.mipStatus = '7';
            // if (['customerChannel', 'customerChannelRole'].includes(itemSetting.prop)) {
            //     setupContext.root.$nextTick(() => {
            //         setupContext.refs.upholdHealder && setupContext.refs.upholdHealder.refleshPage(detailDataLocal.value); // 刷新表单子组件
            //     });
            // }
        };
        const isShowBtnFlow = computed(() => {
            return currentAuth.value; // 审批通过 || 当前操作人 || 流程提交人
        });
        const authorized = ref(false);
        const getIflowhandlers = async (fdId) => {
            // if (env === 'ver') {
            //     authorized.value = true;
            //     return false;
            // }
            const authorityMips = [];
            // const publicPrarms = { fdId, loginName: store.getters.user.userCode };
            let res = null;
            res = await getAuthorByProcessIdApi({ fdProcessId: [fdId], loginName: store.getters.user.userCode });
            if (+res.code === 0 && res.data && res.data.length) {
                const theData = res.data.find(item => item.fdProcessId === fdId);
                authorized.value = theData?.reader;
            }
            if (ctx.$route.query.isToOtherPersons) { // 传阅人也可以查看
                authorityMips.push(ctx.$route.query.isToOtherPersons);
            }
            authorized.value = authorized.value || authorityMips.some(item => item.includes(store.getters.user.userCode));
        };
        const handleCreate = () => {
            const { customerChangeType, customerChangeCode } = detailDataLocal.value;
            const fdTemplateKey = _.get(initDataMenu, customerChangeType + '.flowKey', '');
            mipUrl.value = '';
            // eslint-disable-next-line max-len
            mipUrl.value = `${configurl.iflowUrl}?customerChangeCode=${customerChangeCode}&fdId=${detailDataLocal.value.mipId}&fdTemplateKey=${fdTemplateKey}&userCode=${userCode}&userName=${userName}`;
            createMetaNode();
            window.addEventListener('message', messageFunc, false);
            newMip.value && setTimeout(() => {
                const element = document.getElementsByClassName('customer-change-info')[0];
                // eslint-disable-next-line no-magic-numbers
                element.scrollTo(0, element.getBoundingClientRect().height - Number(MAGIC_HEIGHT)); // 页面滚动到MIP审批位置
                newMip.value = false;
            }, MAGIC_NUMBER.FOUR_HUNDRED);
        };
        const createMetaNode = () => {
            const mipmeta = document.getElementById('mipmeta');
            if (mipmeta) {
                return false;
            }
            const meta = document.createElement('meta');
            meta.httpEquiv = 'Content-Security-Policy';
            meta.content = 'upgrade-insecure-requests';
            meta.id = 'mipmeta';
            document.getElementsByTagName('head')[0].appendChild(meta);
        };
        const timer = 1800;
        // approveProcess 回调提取为独立函数，减少嵌套
        const handleApproveProcess = (params) => {
            return approveProcess(params).then(res => {
                if (res && +res.code === 0) {
                    Message.success('提交成功');
                    const times = setTimeout(async () => {
                        getCustomerByCodeInfo();
                        currentAuth.value = await getNodesAndOperationApi({ fdId: detailDataLocal.value.mipId, loginName: userCode });
                        clearTimeout(times);
                    }, timer);
                } else {
                    Message.error(res.msg);
                }
            }).finally(() => {
                btnloading.value = false;
            });
        };
        // 参数准备辅助函数
        const prepareApproveParams = (eventData) => {
            const { customerChangeCode, mipId } = detailDataLocal.value;
            const { origin, pathname } = window.location;
            const params = eventData.data || {};
            const { tenantCode } = store.getters.currentTenant;
            params.tenantCode = tenantCode;
            params.currentApplicationCode = 'APP201904230047';
            if (params.formParam) {
                const { processParam } = params;
                let isToOtherPersons = '';
                if (processParam.operationType === 'circulate' && processParam.toOtherPersons) {
                    isToOtherPersons = processParam.toOtherPersons;
                }
                // eslint-disable-next-line max-len
                params.formParam.fdUrl = `${origin}${pathname}#/customerChangeFlow?customerChangeCode=${customerChangeCode}&fdId=${mipId}${isToOtherPersons ? `&isToOtherPersons=${isToOtherPersons}` : ''}`;
            }
            return params;
        };
        // draft_submit分支处理
        const handleDraftSubmit = async (params) => {
            try {
                // const { customerChangeType, customerChangeCode } = detailDataLocal.value;
                // const checkApi = _.get(initDataMenu, customerChangeType + '.checkApi');
                // const params = {
                //     customerChangeCode: customerChangeCode
                // };
                // const res = await checkApi();
                // if (res && +res.code === 0) {
                await handleApproveProcess(params);
                // }
            } catch (e) {
                btnloading.value = false;
            }
        };
        // 主流程调度
        const messageFunc = async (event) => {
            if (currentTime.value !== store.getters.iflowPage.pageTime) return;
            if (!(event.data && event.data.data && event.data.success)) return;
            const params = prepareApproveParams(event.data);
            const processParam = params.processParam || {};
            btnloading.value = true;
            if (processParam.operationType === 'draft_submit') {
                await handleDraftSubmit(params);
                return;
            }
            handleApproveProcess(params);
        };
        // eslint-disable-next-line complexity
        const submitMip = async () => {
            const content = window;
            content.frames && content.frames.length && content.frames[0]
                && content.frames[0].postMessage('mbpm_getApprovalData', mipUrl.value);
            content.frames && content.frames.length && content.frames[1]
                && content.frames[1].postMessage('mbpm_getApprovalData', mipUrl.value); // 解决接入了智能客服后，content.frames[0]被占用了的问题
            currentTime.value = new Date().getTime();
            store.commit('updateIflowPage', { pageTime: currentTime.value });
            scrollToHandle();
        };
        const currentTime = ref('');

        // 行业大类判断是否编辑以及运维编辑
        const industryTypeDisabled = computed(() => {
            const { isUpdate, isStatus, isVirtual, isOverseas } = customerTypeData.value;
            if (!isStatus && ((isVirtual || isUpdate) && !isOverseas)) {
                return ['', null, undefined, '1', '5', '6'].includes(detailDataLocal.value.mipStatus?.toString());
            }
            return false;
        });
        // customerOwnerName
        const getVirInitData = (data) => {
            const _data = {
                ..._.pick(data, ['ebcuCustomerType', 'ebcuBuCode', 'customerName',
                    'customerChannelRole', 'isImpExpCustomer',
                    'ebcuEbplCountryCode', 'ebcuEbplProvinceCode', 'ebcuEbplCityCode', 'ebcuDistricts', 'ebcuTowns',
                    'ebcuAddress'
                ]),
                customerOwnerName: userName,
                customerOwnerCode: userCode,
                addressCode: generateAddressArray(data.ebcuEbplCountryCode, data.ebcuEbplProvinceCode, data.ebcuEbplCityCode, data.ebcuDistricts, data.ebcuTowns)
            };
            if (ctx.$route.query.customerChangeType) {
                _data.customerChangeType = ctx.$route.query.customerChangeType;
                _data.isVirtualCustomer = 'Y';
                _data.sysSource = 'LCRM';
                Object.assign(_data, setVirturalData(data));
            }
            return _data;
        };
        const setVirturalData = (data) => {
            return {
                belongCustomerCode: _.get(data, 'customerCode'),
                belongCustomerName: _.get(data, 'customerName'),
                belongCustomerGroupName: _.get(data, 'customerGroupName'),
                belongCustomerGroupCode: _.get(data, 'customerGroupCode'),
                belongIndustryCategoriesName: _.get(data, 'industryCategoriesName'),
                belongCustomerChannel: _.get(data, 'customerChannel'),
                belongRiskLevel: _.get(data, 'riskLevel')
            };
        };
        const splitByLastDash = (str) => {
            const lastIndex = str.lastIndexOf('-');
            return lastIndex === -1 ? [str, ''] : [str.slice(0, lastIndex), str.slice(lastIndex + 1)];
        };
        const getUpdateInitData = (data) => {
            const _data = data;
            if (ctx.$route.query.customerChangeType) {
                _data.customerChangeType = ctx.$route.query.customerChangeType;
            }
            delete _data.updateUserName;
            delete _data.updateUserCode;
            delete _data.updateTime;
            delete _data.createUserName;
            delete _data.createUserCode;
            delete _data.createTime;
            delete _data.ebcuRemark;
            return _data;
        };
        const getStatusInitData = (data) => {
            const _data = data;
            if (ctx.$route.query.customerChangeType) {
                _data.customerChangeType = ctx.$route.query.customerChangeType;
            }
            delete _data.updateUserName;
            delete _data.updateUserCode;
            delete _data.updateTime;
            delete _data.createUserName;
            delete _data.createUserCode;
            delete _data.createTime;
            delete _data.ebcuRemark;
            return _data;
        };
        const initDataMenu = {
            1: {
                initFunc: getVirInitData,
                title: '虚拟客户新增申请',
                api: saveVirtualInfo,
                flowKey: 'CRM_customer_virtual_apply',
                flowApi: submitVirtualFlow
                // checkApi: checkVirtualInfo
            },
            2: {
                initFunc: getUpdateInitData,
                title: '客户信息变更申请',
                api: saveChangeCustomer,
                flowKey: 'CRM_customer_change_apply',
                flowApi: submitChangeFlow
                // checkApi: checkChangeInfo
            },
            3: {
                initFunc: getStatusInitData,
                title: '客户状态变更申请',
                api: saveStatusCustomer,
                flowKey: 'CRM_customer_status_apply',
                flowApi: submitStatusFlow
                // checkApi: checkStatusInfo
            }
        };
        const customerType = {
            2: '1',
            3: '2',
            4: '2',
            5: '3'
        };
        const customerTitle = ref('');
        // eslint-disable-next-line indent
        const getCustomerByCodeInfo = () => {
            const { customerChangeType, customerChangeCode } = ctx.$route.query;
            // if (!_.get(initDataMenu, customerChangeType + '.title')) return;
            let params = {};
            let api = getCustomerByCode;
            if (customerChangeCode || detailDataLocal.value.customerChangeCode) {
                params = {
                    customerChangeCode: customerChangeCode || detailDataLocal.value.customerChangeCode
                };
                if (!params.customerChangeCode) return;
                api = queryFlowByCustomer;
            } else {
                params = {
                    customerCode: ctx.$route.query.customerCode
                };
                if (!params.customerCode) return;
            }
            btnloading.value = true;

            // getCustomerByCode(params)
            // eslint-disable-next-line complexity
            return Promise.all([api(params)]).then(async resArr => {
                let _data = {};
                if (+resArr[0].code === 0 && resArr[0].data) {
                    const _statusChangeType = _.get(resArr[0], 'data.changeInfo.customerChangeType', '')?.toString();
                    const _customerCode = _.get(resArr[0], 'data.changeInfo.customerCode', '');
                    if (customerChangeType) {
                        _data = _.get(initDataMenu, customerChangeType + '.initFunc', () => { })(resArr[0].data);
                        customerTitle.value = _.get(initDataMenu, customerChangeType + '.title', '客户信息变更');
                    } else if (_statusChangeType === '5' && _customerCode) {
                        // 客户状态变更需要拿主档信息 不能用变更单数据
                        const statusRes = await getCustomerByCode({ customerCode: _customerCode });
                        if (statusRes && +statusRes.code === 0) {
                            _data = statusRes.data;
                            _data.customerChangeType = customerType[_statusChangeType];
                            _data = {
                                ..._data,
                                ..._.pick(resArr[0].data.changeInfo, ['id', 'ebcuRemark', 'targetStatus', 'createUserCode', 'createUserName', 'createTime', 'customerChangeCode', 'version']),
                                ..._.pick(resArr[0].data.flowInfo, ['mipId', 'mipStatus', 'contractCode', 'mipUrl'])
                            };
                        }
                    } else {
                        delete resArr[0].data.changeInfo.mipStatus;
                        _data = {
                            ...resArr[0].data.changeInfo,
                            ..._.pick(resArr[0].data.flowInfo, ['mipId', 'mipStatus', 'contractCode', 'mipUrl'])
                        };
                        _data.customerChangeType = customerType[_data.customerChangeType];
                    }
                    customerTitle.value = _.get(initDataMenu, _data.customerChangeType + '.title', '客户信息变更');
                }
                _data.customerChangeType = _data.customerChangeType?.toString();
                if (!customerChangeType && _data.customerChangeType === '1' && _data.customerCode) { // 虚拟客户中的基本信息需要用主客户信息的数据
                    const virtualRes = await getCustomerByCode({ customerCode: _data.belongCustomerCode });
                    if (virtualRes && +virtualRes.code === 0) {
                        Object.assign(_data, setVirturalData(virtualRes.data));
                    }
                }
                if (_data.customerChangeType === '1') {
                    const _customerName = splitByLastDash(_data.customerName);
                    _data.customerName = _customerName[0];
                    _data.virtualName = _customerName[1];
                }
                // 判断客户的客户控制类型非海外/港澳台注册时，默认国家为【中国】
                if (_data.customerChangeType === '2' && !['2'].includes(_data.customerBodyType) && ['', null, undefined].includes(_data.ebcuEbplCountryCode)) {
                    _data.ebcuEbplCountryCode = 'CN';
                    _data.ebcuEbplCountryName = '中国';
                }
                detailDataLocal.value = {};
                handleInfosChange({ form: formatData(_data) });
            }).catch(() => {
                btnloading.value = false;
            }).finally(() => { btnloading.value = false; });
            // return getCustomerByCode({
            //     customerCode: ctx.$route.query.customerCode
            // }).then(res => {
            //     if (res && +res.code === 0) {
            //         detailDataLocal.value = res.data;
            //         setupContext.refs.upholdHealder && setupContext.refs.upholdHealder.updataInitData(detailDataLocal.value); // 刷新表单子组件
            //     }
            // }).finally(() => {
            //     btnloading.value = false;
            // });
        };
        const industryData = ref([]);
        const getIndustryTreeList = () => {
            return getIndustryTree({
                industryStatus: 1 // 0-停用、1-启用
            }).then(res => {
                if (res && +res.code === 0) {
                    industryData.value = res.data;
                }
            });
        };
        const virtualNameChange = (data) => {
            detailDataLocal.value.virtualName = data;
            initCustomerKey = 1;
            isHandleEdit.value = true;
            setupContext.refs.upholdHealder && setupContext.refs.upholdHealder.updataInitData(detailDataLocal.value);
        };
        const addressChange = (form, col, type) => {
            detailDataLocal.value.addressCode = form.addressCode;
            setupContext.refs.upholdHealder && setupContext.refs.upholdHealder.updataInitData(detailDataLocal.value);
            if (form.addressCode && form.addressCode.length > 0) {
                setupContext.root.$nextTick(() => {
                    // 获取当前选中的节点信息
                    const selectedNodes = setupContext.refs.customerAddressRef.getCheckedNodes();
                    if (selectedNodes.length > 0) {
                        const currentNode = selectedNodes[0];
                        // 判断当前节点是否还有子节点（非叶子节点）
                        if (currentNode.hasChildren || !currentNode.isLeaf) {
                            // 方法：通过DOM操作模拟点击，展开下一级
                            triggerNodeExpand();
                        }
                    }
                });
            }
            isHandleEdit.value = true;
        };
        // 部分浏览器多次下拉出现页面卡死问题处理
        const visibleChange = () => {
            setupContext.root.$nextTick(() => {
                // 添加这段代码
                const $el = document.querySelectorAll('.el-cascader-panel .el-cascader-node[aria-owns]');
                Array.from($el).forEach(item => item.removeAttribute('aria-owns'));
            });
        };
        const triggerNodeExpand = () => {
            // 找到当前选中的单选框元素
            const checkedRadios = document.querySelectorAll('.address-popper-custom .el-radio.is-checked');
            if (checkedRadios.length > 0) {
                // 通常最后一个是最新选中的
                const lastCheckedRadio = checkedRadios[checkedRadios.length - 1];
                // 找到相邻的用于展开的箭头图标或元素并点击
                const expandIcon = lastCheckedRadio.nextElementSibling;
                if (expandIcon && expandIcon.click) {
                    expandIcon.click();
                }
            }
        };
        const formatAddress = () => {
            const { ebcuEbplCountryName, ebcuEbplProvinceName, ebcuEbplCityName, ebcuDistrictsName, ebcuTownsName } = detailDataLocal.value;
            const adddresList = [ebcuEbplCountryName, ebcuEbplProvinceName, ebcuEbplCityName, ebcuDistrictsName, ebcuTownsName];
            const _text = adddresList.filter(it => it).join('/');
            return _text || '--';
        };
        const formatIndustry = () => {
            return detailDataLocal.value.industryTypeName || '--';
        };
        const formatTarget = (val, col) => {
            const currentLable = col.options.find(it => it.value === val?.toString())?.label;
            return currentLable || '--';
        };
        const customAppendChange = (val, prop) => {
            // detailDataLocal.value[prop] = val;
            if (val?.length) {
                detailDataLocal.value['industryCategoriesCode'] = getCaseListName(industryData.value, val)[0].industryCode;
                detailDataLocal.value['industryCategoriesName'] = getCaseListName(industryData.value, val)[0].industryName;
                detailDataLocal.value[prop] = val[1];
            } else {
                detailDataLocal.value['industryCategoriesCode'] = '';
                detailDataLocal.value['industryCategoriesName'] = '';
                detailDataLocal.value[prop] = '';
            }
            isHandleEdit.value = true;
            isNeedSaveAndSubmit.value = true;
            setupContext.refs.upholdHealder.updataInitData(detailDataLocal.value);
        };
        const getCaseListName = (obj, pathArray) => {
            // 使用 Lodash 获取嵌套值
            const values = [];

            // 查找第一个ID匹配的对象
            let currentObj = _.find(obj, { industryCode: pathArray[0] });

            if (currentObj) {
                values.push(currentObj);

                // 遍历剩余的路径
                for (let i = 1; i < pathArray.length; i++) {
                    if (currentObj.children) {
                        currentObj = _.find(currentObj.children, { industryCode: pathArray[i] });
                        // eslint-disable-next-line max-depth
                        if (currentObj) {
                            values.push(currentObj);
                        }
                    } else {
                        // values.push('未找到');
                        break;
                    }
                }
            } else {
                // values.push('未找到');
            }

            return values;
        };
        const handleComparison = () => {
            setupContext.refs.comparisonRef.show(detailDataLocal.value.customerChangeCode);
        };
        // 格式化显示地址中文名, 英文名, 本国语 判断与中文一致不展示
        const formatCascaderDataCn = data => {
            return (data.nameCn);
        };
        // 格式化显示地址中文名, 英文名, 本国语 判断与中文一致不展示
        const formatCascaderDataEn = data => {
            return (data.nameEn);
        };
        const showTooltip = ref(false);
        const mouseenterHandle = e => {
            if (e.target.clientWidth < e.target.scrollWidth) {
                showTooltip.value = false;
            } else {
                showTooltip.value = true;
            }
        };
        const getCustomerGroupTipsInfo = () => {
            const params = {
                customerName: detailDataLocal.value.customerName
            };
            if (detailDataLocal.value.virtualName) {
                params.customerName = detailDataLocal.value.customerName + '-' + detailDataLocal.value.virtualName;
            }
            return getCustomerGroupTips(params).then(res => {
                if (res && +res.code === 0) {
                    res.data && Message.warning({
                        showClose: true,
                        message: '客户系相似：' + res.data,
                        type: 'warning'
                    });
                }
            }).finally(() => {
                ++initCustomerKey;
            });
        };
        const setNumberType = (val) => {
            if (!_.isNil(val) && val !== '') {
                val = Number(val);
            }
            return val;
        };
        const numberList = ['contractScale', 'depositAmount', 'receivableAmount', 'overdueNoInvoicedAmount', 'overdueInvoicedAmount'];
        // 处理保存字段格式
        // eslint-disable-next-line complexity
        const saveDataFormat = (data) => {
            data.customerLevel && (data.customerLevel = data.customerLevel.join(','));
            data.businessType && (data.businessType = data.businessType.join(','));
            data.warehouseType && (data.warehouseType = data.warehouseType.join(','));
            data.riskCause && (data.riskCause = data.riskCause.join(','));
            numberList.forEach(it => {
                if (data.hasOwnProperty(it)) {
                    data[it] = setNumberType(data[it]);
                }
            });
            if (data.addressCode?.length) {
                data.ebcuEbplCountryCode = _.nth(data.addressCode, 0) ?? null;
                data.ebcuEbplProvinceCode = _.nth(data.addressCode, 1) ?? null;
                data.ebcuEbplCityCode = _.nth(data.addressCode, 2) ?? null;
                data.ebcuDistricts = _.nth(data.addressCode, 3) ?? null;
                data.ebcuTowns = _.nth(data.addressCode, 4) ?? null;
            }
            if (['', undefined].includes(data.bizRevId)) {
                data.bizRevId = null;
            }
            if (Array.isArray(data.industryType)) {
                data.industryTypeCode = data.industryType[1];
                data.industryType = data.industryType[1];
            }
            if (data.customerChangeType === '1') {
                data.customerName = data.customerName + '-' + data.virtualName;
            }
            return data;
        };
        const currentEditStatus = computed(() => { // 审批分支有变更,需要限制mip提交才行,不然审批分支不一致会导致流程报错
            return detailDataLocal.value.mipId && isNeedSaveAndSubmit.value;
        });
        const validateAddressRequired = (params) => {
            const { customerBodyType, isVirtualCustomer, ebcuEbplCountryCode, ebcuEbplProvinceCode, ebcuEbplCityCode } = params;
            if (isVirtualCustomer === 'Y') return true;
            const isAbroad = customerBodyType?.toString() === '2';
            const isDomestic = ['0', '1'].includes(customerBodyType?.toString());
            if (isAbroad) {
                if (!ebcuEbplCountryCode) {
                    Message.warning('海外/港澳台注册客户，国家不能为空');
                    return false;
                }
            } else if (isDomestic) {
                if (!ebcuEbplCountryCode) {
                    Message.warning('国家不能为空');
                    return false;
                }
                if (!ebcuEbplProvinceCode) {
                    Message.warning('省不能为空');
                    return false;
                }
                if (!ebcuEbplCityCode) {
                    Message.warning('市不能为空');
                    return false;
                }
            }
            return true;
        };
        const submitFlowLoading = ref(false);
        // eslint-disable-next-line complexity
        const handleFlow = async () => {
            try {
                await setupContext.root.$nextTick();
                const params = {
                    customerChangeCode: detailDataLocal.value.customerChangeCode
                };
                submitFlowLoading.value = true;
                if (!params.customerChangeCode) {
                    await handleSave(true);
                    params.customerChangeCode = detailDataLocal.value.customerChangeCode;
                }
                const isEdit = isHandleEdit.value || !_.isEqual(oldDetailData.value, detailDataLocal.value);
                //  isEdit 为false 则页面无修改 直接点击审批
                if (params.customerChangeCode && detailDataLocal.value.mipStatus && isEdit) {
                    // 存在变更单 且有流程创建 且表单有变更 且不是新增虚拟客户 -> 走保存然后直接提交审批流
                    await handleSave(true);
                    submitMip();
                    submitFlowLoading.value = false;
                    return;
                } else if (params.customerChangeCode && detailDataLocal.value.mipStatus && !isEdit) {
                    //  存在变更单 且有流程创建 且表单没有变更 则不用保存 直接提交审批流
                    submitMip();
                    submitFlowLoading.value = false;
                    return;
                }
                if (!params.customerChangeCode) {
                    submitFlowLoading.value = false;
                    return;
                };
                const submitApi = _.get(initDataMenu, detailDataLocal.value.customerChangeType + '.flowApi', () => { });
                // 创建审批流
                submitApi(params).then(res => {
                    if (res && +res.code === 0) {
                        submitFlowLoading.value = false;
                        Message.success('提交成功,请进行mip提交!');
                        if (!ctx.$route.query.customerChangeCode) {
                            const { origin, pathname } = window.location;
                            window.location.assign(`${origin}${pathname}#/customerChangeFlow?customerChangeCode=${detailDataLocal.value.customerChangeCode}`);
                        }
                        newMip.value = true;
                        comfirmDialog('', res.data);
                        // _initData();
                    }
                }).finally(() => {
                    submitFlowLoading.value = false;
                });
            } catch (error) {
                submitFlowLoading.value = false;
            }
        };
        const saveLoading = ref(false);
        const handleSave = async (isSubmit) => {
            if (isSubmit !== true) { // 防止点击事件的回调event事件
                await setupContext.root.$nextTick();
            }
            if (!RegExp(noChineseReg).test(detailDataLocal.value.ebcuNameEn) && customerTypeData.value.isUpdate) {
                return Message.warning('英文格式不对!');
            }
            const data = _.cloneDeep(setupContext.refs.upholdHealder.onsave());
            if (!data) return;
            const params = saveDataFormat(_.cloneDeep(detailDataLocal.value));
            if (detailDataLocal.value.customerChangeType === '1' && !params.virtualName) {
                return Message.warning('虚拟客户新增时,客户名称必填!');
            }
            if (detailDataLocal.value.customerChangeType === '2' && !validateAddressRequired(params)) {
                saveLoading.value = false;
                return;
            }
            if (['', null, undefined].includes(data.teamType)) {
                params.teamType = null;
            } else {
                params.teamType = Number(data.teamType);
            }
            saveLoading.value = isSubmit !== true;
            delete params.customerChangeType;
            const saveApi = _.get(initDataMenu, detailDataLocal.value.customerChangeType + '.api');
            return saveApi(params).then(res => {
                if (+res.code === 0) {
                    saveLoading.value = false;
                    if (isNeedSaveAndSubmit.value && detailDataLocal.value.mipId) {
                        Message.success('保存成功，当前审批流分支可能发生改变,请重新选择审批人');
                        isNeedSaveAndSubmit.value = false;
                    } else {
                        Message.success('保存成功');
                        if (isNeedSaveAndSubmit.value) {
                            isNeedSaveAndSubmit.value = false;
                        }
                    }
                    if (isSubmit === true) {
                        isHandleEdit.value = false;
                        detailDataLocal.value.customerChangeCode = res.data || detailDataLocal.value.customerChangeCode;
                        oldDetailData.value = _.cloneDeep(detailDataLocal.value);
                        return;
                    };
                    const { origin, pathname } = window.location;
                    window.location.assign(`${origin}${pathname}#/customerChangeFlow?customerChangeCode=${res.data || detailDataLocal.value.customerChangeCode}`);
                    _initData();

                    // const tipsText = res.data.includes('CA') ? ',修改内容涉及关键信息，请填写修改原因后，发起流程审批，审批通过后信息才会修改' : '';
                    // comfirmDialog('保存成功' + tipsText, !!tipsText, res.data);
                } else {
                    saveLoading.value = false;
                }
            }).catch(() => {
                saveLoading.value = false;
            });
        };
        // tipsText:提示文字,isMipUrl:true即滚动, true为有审批流
        const comfirmDialog = async (tipsText, isMipUrl, id) => {
            // MessageBox.confirm(tipsText, `提示：`, {
            //     confirmButtonText: '确认',
            //     cancelButtonText: '取消',
            //     showCancelButton: false,
            //     type: 'success'
            // }).then(async () => {
            await _initData(id);
            saveLoading.value = false;
            if (!isMipUrl) return;
            const timer = setTimeout(() => {
                scrollToHandle();
                clearTimeout(timer);
                // eslint-disable-next-line no-magic-numbers
            }, 1000);
            // }).catch(async (action) => {
            //     await _initData(id);
            //     saveLoading.value = false;
            //     if (!isMipUrl) return;
            //     const timer2 = setTimeout(() => {
            //         scrollToHandle();
            //         clearTimeout(timer2);
            //         // eslint-disable-next-line no-magic-numbers
            //     }, 1000);
            // });
        };
        const scrollToHandle = () => {
            const elementRules = document.querySelector(`.customer-change-info`);
            const collapseRules = document.querySelector(`.customer-change-collapse`);
            setupContext.root.$nextTick(() => {
                elementRules.scrollTo({
                    // eslint-disable-next-line no-magic-numbers
                    top: collapseRules.getBoundingClientRect().height - Number(MAGIC_HEIGHT),
                    left: 0,
                    behavior: 'smooth' // 可选值：'auto'（默认）或'smooth'（平滑滚动）
                });
            });
        };
        const addressFilter = (node, keyword) => {
            // 如果关键词为空，则显示所有选项
            if (!keyword) return true;

            // 将节点文本和搜索词都转为大写后进行匹配
            // 使用 node.text 还是 node.label 取决于你数据中配置的字段名
            const nodeText = node.text || node.label || '';
            const upperNodeText = nodeText.toUpperCase();
            const upperKeyword = keyword.toUpperCase();
            if (upperNodeText.indexOf(upperKeyword) > -1) {
                return true;
            }
            const nameEnText = node.data.nameEn?.toUpperCase();
            const nameLoText = node.data.nameLo?.toUpperCase();
            if (nameEnText.indexOf(upperKeyword) > -1) {
                return true;
            }
            // 如果匹配成功，返回 true
            if (nameLoText.indexOf(upperKeyword) > -1) {
                return true;
            }
            return false;
        };
        const encryption = ref({
            idNumber: false
        });
        const handleChangeText = (item) => {
            encryption.value[item.prop] = !encryption.value[item.prop];
            setupContext.refs.upholdHealder && setupContext.refs.upholdHealder.refleshPage(detailDataLocal.value); // 刷新表单子组件
        };
        // 对应加密方法
        const menuList = {
            idNumber: 'idCard'
        };
        const encryptionHandle = (val, p) => {
            const { desensitization } = otherUtils;
            const prop = menuList[p];
            if (!desensitization[prop]) return '';
            if (encryption.value[p]) return val;
            return desensitization[prop](val);
        };
        Bus.$on('customerInfoChange', ({ customerCode }) => {
            // 信息变更按钮才刷新页面
            detailDataLocal.value = {};
            encryption.value = {};
            _initData();
        });
        // eslint-disable-next-line complexity
        onActivated(() => {
            const { customerChangeType, customerChangeCode, customerCode } = ctx.$route.query;
            // 判断非新增时 且 变更单相等 不需要重新请求加载
            if (_.isNil(customerChangeType) && customerChangeCode && customerChangeCode === detailDataLocal.value.customerChangeCode) return;
            // 新增时, 存在相同客户名称且相同变更类型时 不需要重新请求加载
            if (!_.isNil(customerChangeType) && customerCode === detailDataLocal.value.customerCode && customerChangeType === detailDataLocal.value.customerChangeType) return;
            // 非新增时 , 相同变更单编号无需重新请求加载
            if (customerChangeCode && customerChangeCode === detailDataLocal.value.customerChangeCode) return;
            // 新增时, 变更类型相同且客户名称相同, 无需重新加载(虚拟客户)
            if (customerChangeType && customerChangeType === detailDataLocal.value.customerChangeType && customerCode === detailDataLocal.value.belongCustomerCode) return;

            detailDataLocal.value = {};
            encryption.value = {};
            _initData();
            getIndustryTreeList();
            setupContext.refs.upholdHealder && setupContext.refs.upholdHealder.clearValidate(); // 重置校验报错
        });
        return {
            config,
            COLLAPSE,
            detailLoading,
            btnloading,
            disabledFlag,
            code,
            detailDataLocal,
            mipUrl,
            isShowBtn,
            showTooltip,
            dictDatas,
            submitFlowLoading,
            isShowBtnFlow,
            industryData,
            activeCollapses,
            lodash,
            newPageStatus,
            customerTypeData,
            saveLoading,
            industryTypeDisabled,
            customerTitle,
            addressCodeKey,
            customerNameFiledStatus,
            addedDictKeys,
            addressFilter,
            iconCloseEyes,
            iconOpenEyes,
            encryption,
            currentEditStatus,
            isNeedSaveAndSubmit,
            visibleChange,
            handleChangeText,
            encryptionHandle,
            virtualNameChange,
            handleFlow,
            addressChange,
            customAppendChange,
            handleSave,
            formatAddress,
            handleInfosChange,
            submitMip,
            formatTarget,
            formatIndustry,
            handleComparison,
            formatCascaderDataCn,
            formatCascaderDataEn,
            mouseenterHandle
        };
    }
};
</script>
<style lang="less" scoped>
@scrollbarThumbColor: rgba(0, 0, 0, .2);
@scrollbarThumbColorHover: rgba(0, 0, 0, .4);

.customer-cascader-select {
    width: 100%;
}

.address-custom {
    width: 100%;
}

.customer-mip-iframe {
    // overflow: auto;
    display: flex;
    flex-direction: column;

    .top-box {
        .header-box {
            width: 100%;

            h4 {
                text-align: center;
                font-size: 20px;
                margin: 0;
                color: #606266;
            }

            .header-info-crm {
                width: 100%;
                display: flex;
                font-size: 14px;
                border-bottom: 1px solid #dde0e6;
                margin-bottom: 10px;
                padding-bottom: 5px;
                justify-content: space-between;

                .tips {
                    flex: 1;
                    // color: red;
                    color: #606266;
                    line-height: 20px;
                }

                .apply-info {
                    line-height: 20px;
                    color: #606266;
                    margin-left: 10px;
                }
            }
        }

        .detail-toolBar {
            .item-flow-right {
                float: right;

                &.refresh {
                    margin-left: 10px;
                }
            }
        }
    }

    .customer-change-info {
        overflow: auto;

        .upload-demo {
            display: inline-block;
        }

        .down-mould-btn {
            margin-left: 5px;
        }

        .upload-tips {
            display: inline-block;
            margin-left: 10px;
            line-height: 28px;
            font-size: 12px;
            color: #606266;
        }

        .file-infos {
            width: 100%;
            padding: 0 10px 0 0;

            .file-list {
                width: 100%;
                padding: 2px 0 2px 4px;
                display: flex;

                // justify-content: space-between;
                .file-name {

                    // flex: 1;
                    &.upload {
                        width: 500px;
                    }

                    padding-right: 5px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: inline-block;
                }

                .view-btn,
                .delete-btn {
                    width: 200px;
                    display: flex;

                    a {
                        text-decoration: none;
                        color: #4285F5;
                    }

                    .el-button {
                        margin-left: 10px;
                    }

                    .el-button:focus,
                    .el-button:hover,
                    .el-button:active,
                    .el-button.is-disabled {
                        outline: none !important;
                        border-color: transparent !important;
                        /* 可选：如果要去除激活时的边框颜色变化 */
                    }
                }
            }
        }

        .el-collapse-item__content {
            padding-bottom: 5px;
        }

        .el-collapse-item__arrow {
            margin: 0 8px 0 5px;
        }

        .el-button.is-disabled.is-plain,
        .el-button.is-disabled.is-plain:focus,
        .el-button.is-disabled.is-plain:hover {
            border-color: #FFF;
        }

        .width-small {
            width: 340px;
        }

        .width-middle {
            width: 500px;
        }

        .width-large {
            width: 1200px;
        }

        .el-form-item--mini.el-form-item,
        .el-form-item--small.el-form-item {
            margin-bottom: 2px;
        }

        .el-col.el-col-23.form-item {
            .el-form-item.el-form-item--mini {
                margin-bottom: 18px;
            }
        }

        .el-collapse-item__header {
            height: 32px;
        }

        .detail-form-collapse {
            padding-right: 10px;
        }

        .score-config-item-box {
            .item-tittle {
                font-size: 14px;
                font-weight: 600;
                color: #606266;
                margin-left: 28px;
            }
        }

        .rating-score-list-box {
            .el-collapse {
                border-bottom: none;

                .el-collapse-item__header {
                    border-bottom: none;
                }

                .el-collapse-item__wrap {
                    border-bottom: none;
                }
            }
        }
    }

    .ifr {
        width: 100%;
        height: 100vh;
        border: none;
    }

    .el-collapse-item__header {
        color: #606266;
        font-size: 14px;
        font-weight: 600;
    }

    .header-operation {
        margin-top: 10px;
    }

    .resistr-add {
        float: right;
        margin-bottom: 8px;
        margin-right: 8px;
    }

    .customer-name-edit {
        display: flex;

        .customer-name-text {
            flex: 0 0 auto;
            max-width: 400px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .customer-name-tips {
            margin: 0 3px;
        }

        .customer-name-input {
            flex: 1;
        }
    }

    .customer-text-area {
        color: #606266;
        white-space: pre-wrap;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
        margin-top: 6px;
        line-height: 1.2;
    }
    .text-eyes {
        width: 14px;
        margin-left: 4px;
        cursor: pointer;
        position: relative;
        top: 2px;
    }
    .customer-id-number{
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}

.no-auth-reg {
    font-size: 16px;
    padding: 20px;
    background: #fff;
    width: 100%;
}

.my-tooltip-box {
    width: 800px;
}
</style>
<style lang="less">
.address-popper-custom {

    .cascader-custom {
        display: flex;
        justify-content: space-between;

        p {
            flex: 1;
            margin: 0 10px;
            text-align: left;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            min-width: 35px;
            max-width: 90px;
        }
    }
}
</style>
